/**
 * @format
 */
 import {connect} from 'react-redux';

 import {JobListView} from '../components';
 
 const Job = connect()(JobListView);
 
 export {Job};